import { Col, DatePicker, Form, Input, Row, Space, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../components/DraggableModal";
import { EntPersonnelItem } from "../../../models/personnelItem";
import SelectGovernment from "../../../components/selects/SelectGovernment";
import { dateFormat } from "../../../utils";
import dayjs from "dayjs";

enum FormField {
    id, // Уникальный идентификатор кадра
    periodStart, // Дата начала периода (обязательно)
    periodEnd, // Дата окончания периода (обязательно)
    countPolitical, // Количество Политическая должность
    countAdministrative, // Количество Государственные служащие
    countNonState, // Количество Не государственные служащие
    countTop, // Количество сотрудников ТОП-уровня
    countMiddle, // Количество сотрудников МОП-уровня
    countOther, // Количество Другие категории
    countArrived, // Количество Прибывшие
    countDeparted, // Количество Убывшие
    government, // Идентификатор Организации
}

interface IProps {
    show: boolean;
    personal: EntPersonnelItem;
    onHide: () => void;
    onSubmit: (pos: EntPersonnelItem) => Promise<boolean>;
}

export const AddPersonnelModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [startDate, setStartDate] = useState(null);
    const { Text } = Typography;

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.periodStart, value: props.personal.periodStart === null ? undefined : dayjs(props.personal.periodStart) },
            { name: FormField.periodEnd, value: props.personal.periodEnd === null ? undefined : dayjs(props.personal.periodEnd) },
            { name: FormField.countPolitical, value: props.personal.countPolitical },
            { name: FormField.countAdministrative, value: props.personal.countAdministrative },
            { name: FormField.countNonState, value: props.personal.countNonState },
            { name: FormField.countTop, value: props.personal.countTop },
            { name: FormField.countMiddle, value: props.personal.countMiddle },
            { name: FormField.countOther, value: props.personal.countOther },
            { name: FormField.countArrived, value: props.personal.countArrived },
            { name: FormField.countDeparted, value: props.personal.countDeparted },
            { name: FormField.government, value: props.personal.government?.id },
        ]);
    };

    const setEntityFromFields = (): EntPersonnelItem => {
        let res = _.cloneDeep(props.personal);
        res.periodStart = form.getFieldValue(FormField.periodStart);
        res.periodEnd = form.getFieldValue(FormField.periodEnd);
        res.countPolitical = form.getFieldValue(FormField.countPolitical);
        res.countAdministrative = form.getFieldValue(FormField.countAdministrative);
        res.countNonState = form.getFieldValue(FormField.countNonState);
        res.countTop = form.getFieldValue(FormField.countTop);
        res.countMiddle = form.getFieldValue(FormField.countMiddle);
        res.countOther = form.getFieldValue(FormField.countOther);
        res.countArrived = form.getFieldValue(FormField.countArrived);
        res.countDeparted = form.getFieldValue(FormField.countDeparted);
        res.government = form.getFieldValue(FormField.government);
        return res;
    }
    const hideModal = () => {
        props.onHide();
    }
    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) hideModal();

        } finally {
            setLoading(false);
        }
    }


    const handleStartDateChange = (date: any) => {
        setStartDate(date);
    };



    const disableEndDate = (current: any) => {
        return current && current.isBefore(startDate, 'day');
    };
    return (
        <>
            <DraggableModal
                title={props.personal.id === null ? t('general.add') : t('general.edit')}
                visible={props.show}
                onCancel={() => { hideModal() }}
                onSubmit={handleSubmit}
                submitLoading={loading}
                width={1000}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Row style={{ margin: 0 }} gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <div className="block_item_form" >
                                <Form.Item
                                    label={t('titles.governments')}
                                    name={FormField.government}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <SelectGovernment />
                                </Form.Item>
                            </div>


                            <div className="block_item_form" >
                                <Text underline strong >Количество сотрудников</Text>

                                <Form.Item
                                    label={t('personnel.amount_political_personnel')}
                                    name={FormField.countPolitical}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <Input type="number" />
                                </Form.Item>
                                <Form.Item
                                    label={t('personnel.amount_administrative_personnel')}
                                    name={FormField.countAdministrative}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <Input type="number" />
                                </Form.Item>
                                <Form.Item
                                    label={t('personnel.amount_no_civil_personnel')}
                                    name={FormField.countNonState}
                                    rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                >
                                    <Input type="number" />
                                </Form.Item>

                                <Form.Item
                                label={t('personnel.amount_top_personnel')}
                                name={FormField.countTop}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('personnel.amount_mop_personnel')}
                                name={FormField.countMiddle}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('personnel.amount_another_category_personnel')}
                                name={FormField.countOther}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                    
                            </div>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <div className="block_item_form" >
                                <Space.Compact>
                                    <Form.Item
                                        label={t('general.start_date_period')}
                                        name={FormField.periodStart}
                                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                    >
                                        <DatePicker onChange={handleStartDateChange} format={dateFormat} placeholder={t('general.select_date')} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('general.end_date_period')}
                                        name={FormField.periodEnd}
                                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                                    >
                                        <DatePicker disabledDate={disableEndDate} format={dateFormat} placeholder={t('general.select_date')} />
                                    </Form.Item>
                                </Space.Compact>
                            </div>

                            <div className="block_item_form" >
                                <Text underline strong >Убыло прибыло</Text>

                                <Form.Item
                                label={t('personnel.amount_arrivals_period_personnel')}
                                name={FormField.countArrived}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                            <Form.Item
                                label={t('personnel.amount_departures_period_personnel')}
                                name={FormField.countDeparted}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="number" />
                            </Form.Item>

                              
                            </div>
                           
                          
                        </Col>

                    </Row>
                </Form>
            </DraggableModal>
        </>
    )
}
